module.exports = __webpack_public_path__ + "static/media/022.94455a32.jpg";